import { render } from "./CentrapayQRCode.vue?vue&type=template&id=4f72707e&scoped=true&lang=en"
import script from "./CentrapayQRCode.vue?vue&type=script&lang=js"
export * from "./CentrapayQRCode.vue?vue&type=script&lang=js"

import "./CentrapayQRCode.vue?vue&type=style&index=0&id=4f72707e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f72707e"]])

export default __exports__